function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.6,
  strokeWidth: 3.13
}, React.createElement("path", {
  d: "M38.455 25.332l3.218 8.7h6.26a1.534 1.534 0 0 1 1.082 2.678l-5.426 3.584 3.011 6.914a1.64 1.64 0 0 1-2.335 2.049l-7.277-4.092-7.275 4.092a1.64 1.64 0 0 1-2.338-2.05l3.008-6.913-5.426-3.584a1.532 1.532 0 0 1 1.076-2.677h6.261l3.223-8.7a1.67 1.67 0 0 1 2.938 0zM18.174 40.087H5.652a3.13 3.13 0 0 1-3.13-3.13V15.043a3.13 3.13 0 0 1 3.13-3.13h31.305a3.13 3.13 0 0 1 3.13 3.13v3.13"
}), React.createElement("path", {
  d: "M39.077 12.742L33.19 3.916a3.13 3.13 0 0 0-2.599-1.394H12.017a3.13 3.13 0 0 0-2.604 1.394l-5.881 8.826M21.304 2.522v9.391"
}));

var SvgShipmentStar = function SvgShipmentStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShipmentStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shipment-star.520fe312.svg";
export { ForwardRef as ReactComponent };